<template>
    <div v-if="report_type=='personal_report'">
        <div style="text-align:left;">
            <p style="font-size:17px;font-weight:bold;">
                <span>员工姓名：</span><span style="color:#409EFF;font-weight:bold;">{{ rc_result_info.name }}</span>
                <span style="margin-left:15px;">离职风险评估得分：</span>
                <span style="color:#409EFF;font-weight:bold;">{{ rc_result_info.score }}</span><span>/</span>
                <span style="color:#409EFF;font-weight:bold;">{{ rc_result_info.total_score }}</span>
            </p>
            <p style="font-size:15px;">
                <span style="font-weight:bold;">1. 激励九宫格：</span>
                <span>将员工对{{ rc_result_info.motivation_count }}种工作动机的重要程度和满意程度的结果，分别对应填入九宫格，右上角（非常重要且不满意）的动机即为当前需要关注的激励靶心（默认展示3个靶心）。</span>
            </p>
        </div>
        <div>
            <div class="card-title-left">
                <div class="mid">
                    <div>不满意</div>
                </div>
            </div>
            <div class="card-level3">
                <div class="mid">
                    <div v-for="i in rc_result_info.no_sat_no_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
            <div class="card-level2">
                <div class="mid">
                    <div v-for="i in rc_result_info.no_sat_lit_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
            <div class="card-level1">
                <div class="mid">
                    <div v-for="i in rc_result_info.no_sat_very_imp" :key="i" style="color:red;font-weight:bold;">
                        -{{ i }}
                    </div>
                </div>
            </div>
        </div>
        <div style="clear:both;">
            <div class="card-title-left">
                <div class="mid">
                    <div>比较满意</div>
                </div>
            </div>
            <div class="card-level3">
                <div class="mid">
                    <div v-for="i in rc_result_info.lit_sat_no_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
            <div class="card-level2">
                <div class="mid">
                    <div v-for="i in rc_result_info.lit_sat_lit_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
            <div class="card-level2">
                <div class="mid">
                    <div v-for="i in rc_result_info.lit_sat_very_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
        </div>
        <div style="clear:both;">
            <div class="card-title-left">
                <div class="mid">
                    <div>非常满意</div>
                </div>
            </div>
            <div class="card-level3">
                <div class="mid">
                    <div v-for="i in rc_result_info.very_sat_no_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
            <div class="card-level3">
                <div class="mid">
                    <div v-for="i in rc_result_info.very_sat_lit_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
            <div class="card-level3">
                <div class="mid">
                    <div v-for="i in rc_result_info.very_sat_very_imp" :key="i">
                        -{{ i }}
                    </div>
                </div>
            </div>
        </div>
        <div style="clear:both;">
            <div class="card-title-corner">
            </div>
            <div class="card-title-bottom">
                <div class="mid">
                    <div>不重要</div>
                </div>
            </div>
            <div class="card-title-bottom">
                <div class="mid">
                    <div>比较重要</div>
                </div>
            </div>
            <div class="card-title-bottom">
                <div class="mid">
                    <div>非常重要</div>
                </div>
            </div>
        </div>
        <div style="clear:both;text-align:left;">
            <p style="font-size:15px;font-weight:bold;">2. 员工和主管排序TOP5对比（按照重要程度）</p>
            <div style="width:100%;">
                <el-table
                :data="rc_result_info.top_imp"
                style="width: 100%"
                border
                stripe>
                    <el-table-column prop="top_name" label="排名" min-width="14%"></el-table-column>
                    <el-table-column prop="staff_choice" label="员工" min-width="43%"></el-table-column>
                    <el-table-column prop="superior_choice" label="主管" min-width="43%"></el-table-column>
                </el-table>
            </div>
            <p style="font-size:15px;font-weight:bold;">3. 员工和主管排序TOP5对比（按照满意度程度）</p>
            <div style="width:100%;">
                <el-table
                :data="rc_result_info.top_sat"
                style="width: 100%"
                border
                stripe>
                    <el-table-column prop="top_name" label="排名" min-width="14%"></el-table-column>
                    <el-table-column prop="staff_choice" label="员工" min-width="43%"></el-table-column>
                    <el-table-column prop="superior_choice" label="主管" min-width="43%"></el-table-column>
                </el-table>
            </div>
            <p style="font-size:15px;">你对员工的了解程度很好/一般/有待提升。针对员工的工作动机，您可以从如下几个方面展开激励：</p>
            <p style="font-size:15px;">你可以学习如下材料：</p>
        </div>
    </div>
    <div v-else>
        <div style="width:100%;margin-top:15px;">
            <el-table
            :data="rc_result_info"
            style="width: 100%"
            border
            stripe>
                <el-table-column type="index"></el-table-column>
                <el-table-column prop="name" label="姓名" min-width="20%"></el-table-column>
                <el-table-column prop="score" label="离职风险评估得分" min-width="40%"></el-table-column>
                <el-table-column prop="rank" label="离职风险评估排名" min-width="40%"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // rc_result_info: {
            //     name: '张三',
            //     score: 90,
            //     total_score: 100,
            //     motivation_count: 16,
            //     no_sat_no_imp: ['能以自己认为合适的方式开展学习工作', '职位和地位、权力'],
            //     no_sat_lit_imp: [],
            //     no_sat_very_imp: ['工作环境温馨且配套福利齐全（假期、调休、保险、保健等）', '有深造、个人成长发展和学习的机会（如参加培训、行业论坛等）', '合理的薪酬待遇（工资、股票、奖金等）'],
            //     lit_sat_no_imp: [],
            //     lit_sat_lit_imp: [],
            //     lit_sat_very_imp: ['工作中被信任、认可和鼓励', '能以自己认为合适的方式开展学习工作'],
            //     very_sat_no_imp: [],
            //     very_sat_lit_imp: [],
            //     very_sat_very_imp: ['明确的工作目标和方向', '合理的薪酬待遇（工资、股票、奖金等）'],
            //     top_imp: [{top_name: 'TOP1重要', staff_choice: '工作环境温馨且配套福利齐全（假期、调休、保险、保健等）', superior_choice: '有深造、个人成长发展和学习的机会（如参加培训、行业论坛等）'}]
            //     },
        }
    },
    props: ['rc_result_info', 'report_type'],
    methods: {

    }
}
</script>

<style scoped>
    .card-title-left {
        float: left;
        width: 100px;
        height: 180px; 
        margin-top: 5px;
        margin-left: 5px;
        border: none;
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
    }
    .card-title-bottom {
        float: left;
        width: 180px;
        height: 50px; 
        margin-top: 5px;
        margin-left: 5px;
        border: none;
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: bold;
    }
    .card-title-corner {
        float: left;
        width: 100px;
        height: 90px; 
        margin-top: 5px;
        margin-left: 5px;
        border: none;
        display: flex;
        align-items: center;
        font-size: 15px;
    }
    .card-level3 {
        float: left;
        background: #FFF2CC;
        width: 180px;
        height: 180px;
        margin-top: 5px;
        margin-left: 5px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        display: flex;
        align-items: center;
    }
    .card-level2 {
        float: left;
        background: #FFE699;
        width: 180px;
        height: 180px;
        margin-top: 5px;
        margin-left: 5px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        display: flex;
        align-items: center;
    }
    .card-level1 {
        float: left;
        background: #FFC000;
        width: 180px;
        height: 180px;
        margin-top: 5px;
        margin-left: 5px;
        border: 1px solid #ebeef5;
        border-radius: 4px;
        display: flex;
        align-items: center;
    }
    .mid {
        margin-left: auto;
        margin-right: auto;
    }
    .mid div {
        text-align: left;
        padding-left: 5px;
    }
    ::v-deep .el-table__header {
        font-size: 14px;
    }
    .el-table /deep/ th.el-table__cell {
        background-color: #FFC000;
    }
    .el-table /deep/ thead {
        color: #ffffff;
    }
    /* ::v-deep .el-card__body {
        padding: 0px;
    } */
</style>